import styled from "styled-components";
export const ExtraWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
